import { useRouteLoaderData } from "@remix-run/react";

/**
 * Path prefix of the current market ("/th" on the Thailand-forced surface,
 * "" everywhere else). Sourced from the storefront root loader, which reads
 * the x-eql-market-path header set by the server.mjs rewrite. Every
 * storefront href must carry it (via localePath's third argument or by
 * prepending it to raw template links) so navigation never silently drops
 * out of a path-prefixed market.
 *
 * Safe to call from any component under the _storefront route tree; returns
 * "" when the root loader data is unavailable (e.g. error boundaries).
 */
export function useMarketPrefix(): string {
  const data = useRouteLoaderData("routes/($market)._storefront") as
    | { marketPathPrefix?: string | null }
    | undefined;
  return data?.marketPathPrefix || "";
}
